import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

// ─── Suppress benign ResizeObserver loop errors ───────────────────
// These are caused by layout recalculations (e.g., Monaco editor,
// resizable panels) and are harmless. All major browsers emit them.
const _roRe = /ResizeObserver loop/;
const _origOnError = window.onerror;
window.onerror = (message, ...args) => {
	if (typeof message === "string" && _roRe.test(message)) return true;
	if (_origOnError) return _origOnError(message, ...args);
	return false;
};
window.addEventListener("error", (e) => {
	if (e.message && _roRe.test(e.message)) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
});
window.addEventListener("unhandledrejection", (e) => {
	if (e.reason?.message && _roRe.test(e.reason.message)) {
		e.preventDefault();
	}
});

const {
    REACT_APP_SENTRY_DSN,
    REACT_APP_SENTRY_ENVIRONMENT,
} = process.env;

Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    environment: REACT_APP_SENTRY_ENVIRONMENT,
});

const App = () => (
    <div>
        <h1>Hello, world!</h1>
        <div>This is the deployed TCTT components you can use in your application!</div>
        <div style={{ marginTop: "10px" }}>Soon enough, there will be an instructions page with detailed steps on how to import and use them.</div>
    </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
